import { getPlatform, timestamp } from '@/static/js/zjs'

const getters = {
  openid: (state) => state.user.openid,
  appid: () => getPlatform().appid,
  userInfo: (state) => state.user.userInfo,
  userWbGrade: (state) => state.user.userPref.wbGrade || 'grade11',
  userWbGradeCN: (state) => {
    const wbGrade = state.user.userPref.wbGrade || 'grade11'
    const arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
    const arr2 = ['', '上', '下']
    const grade = wbGrade
      ? arr1[wbGrade.substring(5).substring(0, 1)] +
        '年级' +
        arr2[wbGrade.substring(5).substring(1, 2)]
      : '选择年级'
    return grade
  },
  // 是否新用户
  haveBeenSetGrade: (state) => {
    return state.user.haveBeenSetGrade
  },
  // 非静默授权下的微信用户信息
  wechatUserInfo: (state) => {
    return state.user.wechatUserInfo
  },
  // 用户选择的年级
  userGrade: (state) => {
    const wbGrade = state.user.userPref.wbGrade || 'grade11'
    return Number(wbGrade.substr(wbGrade.length - 2, 1))
  },
  // 用户所选择的学期
  userTerm: (state) => {
    const wbGrade = state.user.userPref.wbGrade || 'grade11'
    return Number(wbGrade.substr(wbGrade.length - 1, 1))
  },
  // 用户所选择的教材版本 - 答案核对
  userWbVersion: (state) => {
    return state.user.userPref.wbVersion
  },
  userSettingBookVersion: (state) => {
    return state.user.settingBookVersion
  },
  // 用于监听版本,年级,学期, 是否发生了变化
  // 因更改年级学期版本发生的vuex的数据变更动作, 应放到更改vuex中年级版本学期之前, 否则回产生异步问题
  // 会导 watch userSettingGradeOrTermOrVersionsChanged 触发时, 后续vuex数据还未变更
  userSettingGradeOrTermOrVersionsChanged: (state) => {
    const versionsText = state.user.settingBookVersion.map((v) => v.editionId).join(',')
    const wbGrade = state.user.userPref.wbGrade || 'grade11'
    const gradeText = wbGrade.substr(wbGrade.length - 2, 1)
    // 因为现在学期变化不影响书籍的展示和筛选, 暂不监听学期变化
    return `${gradeText}:${versionsText}`
  },
  // 用户的vip等级 "sv" "nv"
  vip: (state) => state.user.userInfo.vipLevel || 'nv',
  vipEndTime: (state) => state.user.userInfo.vipEndTime,
  // 拥有家长锁特权
  isHasParentLock: (state) => {
    const { lockExpireTime, vipLevel } = state.user.userInfo
    return vipLevel !== 'nv' || (lockExpireTime && timestamp() < timestamp(lockExpireTime))
  },
  // 是否作业宝用户
  haveBasicServicePaid(state) {
    return !state.user.userInfo.basicServicePaid === 'N'
  },
  // 是否关注了平台
  subscribe(state) {
    return state.user.subscribe
  },
  currentHoliday(state) {
    return state.holidayBook.currentHoliday
  },
  supportHolidayBook(state) {
    return state.holidayBook.currentHoliday && state.holidayBook.currentHoliday.name
  },
  // 年级字典
  dicSettingGrade(state) {
    return state.dictionary.settingGrade
  },
  // 版本字典, 当前年级下的科目
  dicSettingCourses(state) {
    return state.dictionary.settingCourses
  },
  // 科目字典, 所有科目
  dicBookCourses(state) {
    return state.dictionary.bookCourses
  }
}

export default getters
